<template>
  <div class="home">
    <Helmet>
      <title>inte-QT | Managed L3 Internet Global Services</title>
      <meta name="title" content="inte-QT | Managed L3 Internet Global Services" />
      <meta
        name="description"
        content="Internet access in more than 190 countries around the world offering a variety of solutions. Dedicated Lines, Business Broadband and Wireless Connect."
      />
      <link rel="canonical" href="https://www.inte-qt.com/" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.inte-qt.com/" />
      <meta property="og:title" content="inte-QT | Managed L3 Internet Global Services" />
      <meta
        property="og:description"
        content="Internet access in more than 190 countries around the world offering a variety of solutions. Dedicated Lines, Business Broadband and Wireless Connect."
      />
      <meta property="og:image" content="https://www.inte-qt.com/images/fgarNxn.png" />
      <meta property="og:site_name" content="inte-QT" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.bitsnbyteglobal.com/" />
      <meta property="twitter:title" content="inte-QT | Managed L3 Internet Global Services" />
      <meta
        property="twitter:description"
        content="Internet access in more than 190 countries around the world offering a variety of solutions. Dedicated Lines, Business Broadband and Wireless Connect."
      />
      <meta property="twitter:image" content="https://www.inte-qt.com/images/fgarNxn.png" />
      <meta name="twitter:image:alt" content="Company Logo" />
    </Helmet>

    <!-- Celebration Popup -->
    <div v-if="showPopup" class="popup-container">

      <!-- Glitter Animation -->
      <div v-if="showGlitters" class="glitter-container">
        <div
          v-for="n in 30"
          :key="n"
          class="glitter"
          :style="{
            left: Math.random() * 100 + 'vw',
            top: Math.random() * 100 + 'vh',
            animationDelay: Math.random() + 's'
          }"
        ></div>
      </div>

      <!-- Popup Box -->
      <div class="popup-box">
        <img :src="companylogo" alt="Company Logo" class="popup-logo" />
        <h2>We are one of the FT1000: Fastest-Growing Companies in Europe 2025!</h2>
        <p>(Source: Financial Times, Forbes España)</p>
      </div>
    </div>

    <!-- Page Content -->
    <BigBanner />
    <div>
      <h2 class="mx-auto text-center center-header pt-5 mt-5">Our Services</h2>
      <OurServices />
    </div>
    <div><Typewriter /></div>
    <div>
      <a href="https://portal.inte-qt.com/auth/login/" target="_blank" rel="noopener noreferrer">
        <h2 class="mx-auto text-center center-header pt-5 mt-5">Aeta: Revolutionizing Connectivity</h2>
      </a>
      <Inteqt />
    </div>
    <div>
      <h2 class="text-center mx-auto center-header center-header__title">Why become our partner?</h2>
      <PartnerBenefits />
      <div class="text-center">
        <i class="fas fa-chevron-down my-4 partnerBenefits__arrow"></i>
        <DinamicLink url="/partner-center" name="Read more" />
      </div>
    </div>
    <div><GlobalNsocComponent /></div>
    <div>
      <h2 class="text-center center-header mx-auto center-header__title">We help not One, but many Industries.</h2>
      <CarouselIndu />
    </div>
    <div>
      <h2 class="mx-auto text-center center-header pt-5 mt-5">G.E.M.S: Global Edge Managed Services</h2>
      <GemsSection />
    </div>
    <div><EventsComponent /></div>
    <div><TestimonialCarousel /></div>
    <GetInTouch />
  </div>
</template>

<script>
import BigBanner from '@/components/BigBanner.vue';
import CarouselIndu from '@/components/CarouselIndu.vue';
import companylogo from '@/assets/images/logo.jpg';
import TestimonialCarousel from '@/components/TestimonialCarousel.vue';
import Typewriter from '@/components/Typewriter.vue';
import Inteqt from '@/components/Inteqt.vue';
import EventsComponent from '@/components/EventsComponent.vue';
import OurServices from '@/components/OurServices.vue';
import GetInTouch from '@/components/GetInTouch.vue';
import PartnerBenefits from '@/components/PartnerBenefits.vue';
import DinamicLink from '@/components/DinamicLink.vue';
import GlobalNsocComponent from '@/components/GlobalNsocComponent.vue';
import GemsSection from '@/components/GemsSection.vue';

export default {
  name: 'HomePage',
  components: {
    BigBanner,
    CarouselIndu,
    TestimonialCarousel,
    Typewriter,
    Inteqt,
    EventsComponent,
    OurServices,
    GetInTouch,
    PartnerBenefits,
    DinamicLink,
    GlobalNsocComponent,
    GemsSection
  },
  data() {
    return {
      showPopup: true,
      showGlitters: false,
      companylogo
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.startCelebration();
  },
  methods: {
    startCelebration() {
      this.showGlitters = true;
      this.showPopup = true;
      setTimeout(() => {
        this.showPopup = false;
        this.showGlitters = false;
      }, 6000); // Show for 4 seconds
    }
  }
};
</script>

<style scoped>
/* Popup Styles */
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-box {
  background: white;
  padding: 30px 20px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  text-align: center;
  width: 350px;
  max-width: 90%;
  animation: popup-fade 0.5s ease;
}

@keyframes popup-fade {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.popup-logo {
  width: 300px;
  margin-bottom: 20px;
}

/* Glitter Animation */
.glitter-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  pointer-events: none;
  z-index: 999;
}

.glitter {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: gold;
  animation: glitter 5s ease-out forwards;
  opacity: 0.8;
}

@keyframes glitter {
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(200px) scale(0);
    opacity: 0;
  }
}

.glitter:nth-child(odd) {
  background: #ffd700;
}
.glitter:nth-child(even) {
  background: #fff8dc;
}
</style>
